import { axios } from "../../../../constants/axiosConfig";
import { getCnpjUrl } from "../../../../helpers/functions";
import {
  getHistoricoImportacaoRequest,
  getHistoricoImportacaoSuccess,
  getHistoricoImportacaoFailure,
  getNotificacaoImportacaoRequest,
  getNotificacaoImportacaoSuccess,
  getNotificacaoImportacaoFailure,
  clearNotificacaoImportacaoSuccess,
  onImportacaoRequest,
  onImportacaoSuccess,
} from "./reducers";


export const getHistoricoImportacao = (params, prevData) => {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;

  return async (dispatch) => {
    dispatch({ type: getHistoricoImportacaoRequest });

    await axios
      .get(`Importacao/${cnpj}`, { params })
      .then((res) => {
        if (getCnpjUrl() === cnpj)
          dispatch({
            type: getHistoricoImportacaoSuccess,
            payload: res.data,
          });
        else if (prevData?.Resultado.some(item => item.cnpj === getCnpjUrl()))
          dispatch({
            type: getHistoricoImportacaoSuccess,
            payload: prevData,
          });
      })
      .catch((err) => {
        dispatch({
          type: getHistoricoImportacaoFailure,
          payload: err.response,
        });
      });
  };
};

export const getNotificacaoImportacao = (idImportacao, tipo, params) => {
  return async (dispatch) => {
    dispatch({ type: getNotificacaoImportacaoRequest });

    await axios
      .get(`Importacao/${idImportacao}/notificacoes`, { params: { ...params, tipo } })
      .then((res) => {
        dispatch({
          type: getNotificacaoImportacaoSuccess,
          payload: { idImportacao, [`tipo${tipo}`]: res.data },
        });
      })
      .catch((err) => {
        dispatch({
          type: getNotificacaoImportacaoFailure,
          payload: err.response,
        });
      });
  };
};

export const clearNotificacaoImportacao = () => {
  return (dispatch) => {
    dispatch({ type: clearNotificacaoImportacaoSuccess });
  };
};

const isModuloCorreto = (modulo) => {
  const icmsModule = JSON.parse(sessionStorage.getItem("icmsModule"));
  if (icmsModule) {
    return modulo === 'eRecuperadorSegregadorIcms';
  } else {
    return modulo === 'eRecuperadorPisCofins';
  }
}

export const onImportacao = (hub) => {
  return (dispatch) => {
    dispatch({ type: onImportacaoRequest });

    hub.on("Mensagens_Importacao", async (data) => {
      const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany"))?.Cnpj;

      if (cnpj === data.cnpj && /* Valida a empresa */
        isModuloCorreto(data.modulo)) /* Valida se a mensagem é para o módulo atual */ {
        await dispatch({ type: onImportacaoSuccess, payload: data });
      }
    });
  };
};